import houseWithSolar from '~shared-assets/images/house-with-solar.jpg';
import styled from 'styled-components';

export const STANDARD_MARGIN = '5%';

export const DesktopLeftSide = styled.div({
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '32px',
});

export const DesktopRightSide = styled.div({
  position: 'relative',
  width: '50%',
});

export const DesktopRightSideContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'relative',
  height: '100%',
});

export const BackgroundImage = styled.div({
  position: 'absolute',
  width: '100%',
  height: '100%',
  content: '""',
  backgroundSize: 'cover',
  backgroundImage: `url('${houseWithSolar}')`,
  backgroundPositionX: '75%',
});

export const BackgroundShading = styled.div({
  position: 'absolute',
  right: 0,
  bottom: 0,
  top: 0,
  width: '100%',
  background: 'rgba(0,0,0,0.6)',
});

export const MobileTopPart = styled.div({
  position: 'relative',
  height: 'fit-content',
});

export const MobileMiddlePart = styled.div({
  marginTop: '32px',
  marginBottom: '32px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '12px',
});

export const MobileBottomPart = styled.div({
  position: 'relative',
  paddingBottom: '96px',
});
